import * as Yup from 'yup'

import { EMPTY_STRING } from '../../../constants/common'
import { POST_AGE_MAX_VALUE } from '../NewsboardPostForm'

import { NEWSBOARD_POST_PROFILE_EDIT_POST_AGE_FIELD_NAME } from './NewsboardPostProfileHeaderEditPostAgeField.constants'

export function getNewsboardPostProfileEditPostAgeInitialValues(postAge) {
  return {
    [NEWSBOARD_POST_PROFILE_EDIT_POST_AGE_FIELD_NAME]:
      postAge == null ? EMPTY_STRING : String(postAge),
  }
}

export function getNewsboardPostProfileEditPostAgePayload(values) {
  const value = values[NEWSBOARD_POST_PROFILE_EDIT_POST_AGE_FIELD_NAME]

  return {
    [NEWSBOARD_POST_PROFILE_EDIT_POST_AGE_FIELD_NAME]:
      value === EMPTY_STRING || value == null ? null : Number(value),
  }
}

export function getNewsboardPostProfileEditPostAgeValidationSchema(t) {
  return Yup.object({
    [NEWSBOARD_POST_PROFILE_EDIT_POST_AGE_FIELD_NAME]: Yup.number()
      .transform((value, originalValue) =>
        originalValue === EMPTY_STRING ? undefined : value
      )
      .typeError(() => true)
      .required(() => true)
      .integer(() => true)
      .min(0, () => true)
      .max(POST_AGE_MAX_VALUE, () =>
        t('Newsboard.PostAgeMaxIncorrectValueKey', { age: POST_AGE_MAX_VALUE })
      ),
  })
}
